import { renderTableTitle } from "@/utils/render.jsx";
export default {
  name: "cor-list",
  props: {
    org: {
      type: Object,
      default() {
        return {};
      }
    },
    searchValue: {
      type: String,
      default() {
        return "";
      }
    }
  },
  data() {
    const h = this.$createElement;
    return {
      config: {
        map: {
          dataPath: "data.retVal.datas",
          message: "msg",
          totalPath: "data.retVal.totalRows"
        },
        ref: "proTable",
        format: {
          formatCurrent: "(page.current - 1) * page.pageSize"
        },
        request: "/api/userOrganizationAssociate/member/page",
        search: {
          value: {
            orgId: "",
            serach: ""
          }
        },
        columns: [{
          type: "selection",
          width: 60,
          align: "center"
        }, {
          title: $t("fqmy2", "姓名"),
          renderHeader: (h, {
            column
          }) => {
            // 使用列标题保持翻译一致，并按实际宽度决定是否显示提示。
            return renderTableTitle(column.title, column, h);
          },
          key: "userName",
          notShowSearch: true,
          notShowForm: true
        }, {
          title: $t("haa72", "手机"),
          renderHeader: (h, {
            column
          }) => {
            // 使用列标题保持翻译一致，并按实际宽度决定是否显示提示。
            return renderTableTitle(column.title, column, h);
          },
          key: "mobile",
          notShowSearch: true,
          notShowForm: true
        }, {
          title: $t("padf2", "邮箱"),
          renderHeader: (h, {
            column
          }) => {
            // 使用列标题保持翻译一致，并按实际宽度决定是否显示提示。
            return renderTableTitle(column.title, column, h);
          },
          key: "email",
          notShowSearch: true,
          notShowForm: true
        }, {
          title: $t("pgxs2", "部门"),
          renderHeader: (h, {
            column
          }) => {
            // 使用列标题保持翻译一致，并按实际宽度决定是否显示提示。
            return renderTableTitle(column.title, column, h);
          },
          notShowSearch: true,
          notShowForm: true,
          render: (itemh, {
            row
          }) => {
            return h("span", [row.name]);
          }
        }],
        table: {
          stripe: false,
          "show-summary": false
        },
        page: {
          "show-elevator": false
        },
        hide: {
          search: true,
          toolBar: true
        }
      }
    };
  },
  watch: {
    "org.id": function (val) {
      this.config.search.value.orgId = val;
      this.searchUser();
    },
    searchValue(val) {
      if (!val) {
        this.config.search.value.userName = "";
        this.searchUser();
      }
    }
  },
  methods: {
    openView(key, item) {
      switch (key) {
        case "detail":
          this.$emit("detail", item);
          break;
        default:
          break;
      }
    },
    searchByValue(val) {
      this.config.search.value.orgId = "";
      this.config.search.value.userName = val;
      this.searchUser();
    },
    /*
     ** 搜索成员
     */
    searchUser() {
      this.$refs[this.config.ref].searchAction();
    }
  }
};